var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgContentPagesIconDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.414,
    height: 20.414,
    viewBox: "0 0 17.414 20.414",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "ContentPagesIcon",
    d: "M15,3V7a1,1,0,0,0,1,1h4M15,3H11A2,2,0,0,0,9,5V15a2,2,0,0,0,2,2h7a2,2,0,0,0,2-2V8M15,3l5,5m-4,9v2a2,2,0,0,1-2,2H7a2,2,0,0,1-2-2V9A2,2,0,0,1,7,7H9",
    transform: "translate(-4 -1.586)",
    fill: "none",
    stroke: "#212121",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContentPagesIconDark);
export default __webpack_public_path__ + "static/media/ContentPagesIconDark.8408da40dfba0420d22e8aed3183db6b.svg";
export { ForwardRef as ReactComponent };